// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/Contact.css - UPDATED WITH LIGHT THEME */

.contact-page {
  padding: 4rem 1rem; /* Added more vertical padding */
  background: var(--gradient-hero); /* Use light theme gradient */
  min-height: calc(100vh - var(--navbar-height)); /* Ensure minimum height */
  padding-top: var(--navbar-height); /* Add space for navbar */
}

.contact-page .container {
  max-width: 900px; /* Consistent max width */
}

.contact-page-header {
  text-align: center;
  margin-bottom: 3rem; /* Increased spacing */
}

.contact-page-header h1 {
  font-size: clamp(2.2rem, 5vw, 3rem); /* Slightly larger */
  color: var(--text-primary); /* Dark text */
  margin-bottom: 1rem;
  font-weight: 600;
}

.contact-page-header p {
  font-size: clamp(1rem, 2vw, 1.15rem); /* Slightly larger */
  color: var(--text-secondary); /* Medium gray text */
  max-width: 600px;
  margin: 0 auto;
}

.contact-card {
  background: var(--bg-primary); /* White background */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: var(--border-radius-2xl); /* More rounded */
  padding: clamp(2rem, 5vw, 3rem);
  box-shadow: var(--shadow-xl); /* Use defined shadow */
  margin: 0 auto;
}

/* Details Grid - remains 3 columns, adjust styling */
.contact-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Responsive columns */
  gap: 2rem; /* Increased gap */
  text-align: center;
  margin-bottom: 3rem; /* Increased spacing */
}

.contact-detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}

.contact-icon {
  width: 55px; /* Slightly larger */
  height: 55px;
  flex-shrink: 0;
  background: var(--gradient-button); /* Red gradient */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem; /* Increased spacing */
  box-shadow: var(--shadow-lg); /* Add shadow */
}

.contact-icon svg {
  width: 26px; /* Slightly larger */
  height: 26px;
  color: var(--text-on-gradient); /* White icon */
}

.contact-detail-item h3 {
  font-size: 1.15rem; /* Slightly larger */
  color: var(--text-primary); /* Dark text */
  margin-bottom: 0.5rem; /* Increased spacing */
  font-weight: 600; /* Bolder */
}

.contact-detail-item p,
.contact-detail-item a {
  font-size: 1rem; /* Standard text size */
  color: var(--text-secondary); /* Medium gray */
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-detail-item a:hover {
  color: var(--text-accent); /* Red on hover */
}

.contact-divider {
  border: none;
  height: 1px;
  background-color: var(--border-primary); /* Light border */
  margin: 0 auto 3rem auto; /* Increased spacing */
  width: 90%; /* Wider divider */
}

.contact-form-section h2 {
  text-align: center;
  color: var(--text-accent); /* Red heading */
  margin-bottom: 2.5rem; /* Increased spacing */
  font-size: 1.8rem; /* Larger heading */
  font-weight: 600;
}

.contact-form .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.contact-form .form-group {
  margin-bottom: 1.5rem;
}

.contact-form .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-primary); /* Dark label */
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
}

.contact-form .form-group input,
.contact-form .form-group textarea {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid var(--border-primary); /* Light border */
  border-radius: var(--border-radius-lg); /* Consistent rounding */
  background: var(--bg-secondary); /* Very light gray background */
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
}
.contact-form .form-group input::placeholder,
.contact-form .form-group textarea::placeholder {
  color: #9CA3AF; /* gray-400 equivalent */
}

.contact-form .form-group input:focus,
.contact-form .form-group textarea:focus {
  outline: none;
  border-color: var(--text-accent); /* Red border */
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15); /* Red ring, slightly lighter */
  background: var(--bg-primary); /* White background on focus */
}

.contact-form textarea {
  resize: vertical;
  min-height: 120px;
}

.contact-form .button-wrapper {
  text-align: center;
  margin-top: 1.5rem; /* Increased spacing */
}

/* Use primary auth button style */
.contact-form .submit-button {
  /* Inherit from .auth-button in Auth.css/App.css */
  /* If Auth.css isn't globally imported, copy styles here */
  background-image: var(--gradient-button);
  background-color: var(--primary-red-medium);
  color: var(--text-on-gradient);
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
  border: none;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
}

.contact-form .submit-button:hover:not(:disabled) {
  box-shadow: var(--shadow-button-hover);
  transform: scale(1.03);
}

.contact-form .submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  background-image: none; /* Remove gradient when disabled */
  background-color: var(--border-primary); /* Gray background */
  color: var(--text-secondary); /* Gray text */
}

/* Messages */
.contact-form .success-message,
.contact-form .error-message {
  padding: 1rem;
  border-radius: var(--border-radius-lg);
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 0.9rem;
}
.contact-form .success-message {
  background: var(--success-bg-light);
  color: var(--success-color);
  border: 1px solid var(--success-color);
}
.contact-form .error-message {
  background: var(--error-bg-light);
  color: var(--error-color);
  border: 1px solid var(--error-color);
}


/* Tooltip remains dark for contrast */
.button-wrapper .tooltip-text {
  visibility: hidden;
  width: 220px;
  background-color: #333; /* Dark gray */
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -110px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.button-wrapper .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.button-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 768px) {
  .contact-form .form-grid {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .contact-details-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 480px) {
  .contact-card { padding: 1.5rem; }
  .contact-page-header h1 { font-size: 1.8rem; }
  .contact-page-header p { font-size: 1rem; }
  .contact-details-grid { gap: 1.5rem; }
}`, "",{"version":3,"sources":["webpack://./src/styles/Contact.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,kBAAkB,EAAE,gCAAgC;EACpD,gCAAgC,EAAE,6BAA6B;EAC/D,8CAA8C,EAAE,0BAA0B;EAC1E,iCAAiC,EAAE,yBAAyB;AAC9D;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,mCAAmC,EAAE,oBAAoB;EACzD,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC,EAAE,oBAAoB;EAC1D,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B,EAAE,qBAAqB;EACpD,uCAAuC,EAAE,sBAAsB;EAC/D,uCAAuC,EAAE,iBAAiB;EAC1D,+BAA+B;EAC/B,4BAA4B,EAAE,uBAAuB;EACrD,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,2DAA2D,EAAE,uBAAuB;EACpF,SAAS,EAAE,kBAAkB;EAC7B,kBAAkB;EAClB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,YAAY;EACZ,cAAc;EACd,kCAAkC,EAAE,iBAAiB;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB,EAAE,sBAAsB;EAC9C,4BAA4B,EAAE,eAAe;AAC/C;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,YAAY;EACZ,8BAA8B,EAAE,eAAe;AACjD;;AAEA;EACE,kBAAkB,EAAE,oBAAoB;EACxC,0BAA0B,EAAE,cAAc;EAC1C,qBAAqB,EAAE,sBAAsB;EAC7C,gBAAgB,EAAE,WAAW;AAC/B;;AAEA;;EAEE,eAAe,EAAE,uBAAuB;EACxC,4BAA4B,EAAE,gBAAgB;EAC9C,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uCAAuC,EAAE,iBAAiB;EAC1D,wBAAwB,EAAE,sBAAsB;EAChD,UAAU,EAAE,kBAAkB;AAChC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,qBAAqB,EAAE,sBAAsB;EAC7C,iBAAiB,EAAE,mBAAmB;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B,EAAE,eAAe;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,uCAAuC,EAAE,iBAAiB;EAC1D,sCAAsC,EAAE,wBAAwB;EAChE,+BAA+B,EAAE,+BAA+B;EAChE,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;AACA;;EAEE,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;;EAEE,aAAa;EACb,gCAAgC,EAAE,eAAe;EACjD,6CAA6C,EAAE,+BAA+B;EAC9E,6BAA6B,EAAE,8BAA8B;AAC/D;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA,kCAAkC;AAClC;EACE,kDAAkD;EAClD,0DAA0D;EAC1D,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB,EAAE,kCAAkC;EAC1D,uCAAuC,EAAE,oBAAoB;EAC7D,4BAA4B,EAAE,cAAc;AAC9C;;AAEA,aAAa;AACb;;EAEE,aAAa;EACb,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;AACtC;;;AAGA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB,EAAE,cAAc;EACtC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,0BAA0B;IAC1B,MAAM;EACR;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB,eAAe,EAAE;EACjC,0BAA0B,iBAAiB,EAAE;EAC7C,yBAAyB,eAAe,EAAE;EAC1C,wBAAwB,WAAW,EAAE;AACvC","sourcesContent":["/* frontend/src/styles/Contact.css - UPDATED WITH LIGHT THEME */\n\n.contact-page {\n  padding: 4rem 1rem; /* Added more vertical padding */\n  background: var(--gradient-hero); /* Use light theme gradient */\n  min-height: calc(100vh - var(--navbar-height)); /* Ensure minimum height */\n  padding-top: var(--navbar-height); /* Add space for navbar */\n}\n\n.contact-page .container {\n  max-width: 900px; /* Consistent max width */\n}\n\n.contact-page-header {\n  text-align: center;\n  margin-bottom: 3rem; /* Increased spacing */\n}\n\n.contact-page-header h1 {\n  font-size: clamp(2.2rem, 5vw, 3rem); /* Slightly larger */\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.contact-page-header p {\n  font-size: clamp(1rem, 2vw, 1.15rem); /* Slightly larger */\n  color: var(--text-secondary); /* Medium gray text */\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.contact-card {\n  background: var(--bg-primary); /* White background */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: var(--border-radius-2xl); /* More rounded */\n  padding: clamp(2rem, 5vw, 3rem);\n  box-shadow: var(--shadow-xl); /* Use defined shadow */\n  margin: 0 auto;\n}\n\n/* Details Grid - remains 3 columns, adjust styling */\n.contact-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Responsive columns */\n  gap: 2rem; /* Increased gap */\n  text-align: center;\n  margin-bottom: 3rem; /* Increased spacing */\n}\n\n.contact-detail-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n}\n\n.contact-icon {\n  width: 55px; /* Slightly larger */\n  height: 55px;\n  flex-shrink: 0;\n  background: var(--gradient-button); /* Red gradient */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.25rem; /* Increased spacing */\n  box-shadow: var(--shadow-lg); /* Add shadow */\n}\n\n.contact-icon svg {\n  width: 26px; /* Slightly larger */\n  height: 26px;\n  color: var(--text-on-gradient); /* White icon */\n}\n\n.contact-detail-item h3 {\n  font-size: 1.15rem; /* Slightly larger */\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 0.5rem; /* Increased spacing */\n  font-weight: 600; /* Bolder */\n}\n\n.contact-detail-item p,\n.contact-detail-item a {\n  font-size: 1rem; /* Standard text size */\n  color: var(--text-secondary); /* Medium gray */\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.contact-detail-item a:hover {\n  color: var(--text-accent); /* Red on hover */\n}\n\n.contact-divider {\n  border: none;\n  height: 1px;\n  background-color: var(--border-primary); /* Light border */\n  margin: 0 auto 3rem auto; /* Increased spacing */\n  width: 90%; /* Wider divider */\n}\n\n.contact-form-section h2 {\n  text-align: center;\n  color: var(--text-accent); /* Red heading */\n  margin-bottom: 2.5rem; /* Increased spacing */\n  font-size: 1.8rem; /* Larger heading */\n  font-weight: 600;\n}\n\n.contact-form .form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.contact-form .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.contact-form .form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary); /* Dark label */\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n}\n\n.contact-form .form-group input,\n.contact-form .form-group textarea {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  border: 1px solid var(--border-primary); /* Light border */\n  border-radius: var(--border-radius-lg); /* Consistent rounding */\n  background: var(--bg-secondary); /* Very light gray background */\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n.contact-form .form-group input::placeholder,\n.contact-form .form-group textarea::placeholder {\n  color: #9CA3AF; /* gray-400 equivalent */\n}\n\n.contact-form .form-group input:focus,\n.contact-form .form-group textarea:focus {\n  outline: none;\n  border-color: var(--text-accent); /* Red border */\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15); /* Red ring, slightly lighter */\n  background: var(--bg-primary); /* White background on focus */\n}\n\n.contact-form textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.contact-form .button-wrapper {\n  text-align: center;\n  margin-top: 1.5rem; /* Increased spacing */\n}\n\n/* Use primary auth button style */\n.contact-form .submit-button {\n  /* Inherit from .auth-button in Auth.css/App.css */\n  /* If Auth.css isn't globally imported, copy styles here */\n  background-image: var(--gradient-button);\n  background-color: var(--primary-red-medium);\n  color: var(--text-on-gradient);\n  padding: 0.9rem 2.5rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: var(--border-radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n}\n\n.contact-form .submit-button:hover:not(:disabled) {\n  box-shadow: var(--shadow-button-hover);\n  transform: scale(1.03);\n}\n\n.contact-form .submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n  background-image: none; /* Remove gradient when disabled */\n  background-color: var(--border-primary); /* Gray background */\n  color: var(--text-secondary); /* Gray text */\n}\n\n/* Messages */\n.contact-form .success-message,\n.contact-form .error-message {\n  padding: 1rem;\n  border-radius: var(--border-radius-lg);\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-size: 0.9rem;\n}\n.contact-form .success-message {\n  background: var(--success-bg-light);\n  color: var(--success-color);\n  border: 1px solid var(--success-color);\n}\n.contact-form .error-message {\n  background: var(--error-bg-light);\n  color: var(--error-color);\n  border: 1px solid var(--error-color);\n}\n\n\n/* Tooltip remains dark for contrast */\n.button-wrapper .tooltip-text {\n  visibility: hidden;\n  width: 220px;\n  background-color: #333; /* Dark gray */\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 8px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -110px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.button-wrapper .tooltip-text::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #333 transparent transparent transparent;\n}\n\n.button-wrapper:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n\n@media (max-width: 768px) {\n  .contact-form .form-grid {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n  .contact-details-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .contact-card { padding: 1.5rem; }\n  .contact-page-header h1 { font-size: 1.8rem; }\n  .contact-page-header p { font-size: 1rem; }\n  .contact-details-grid { gap: 1.5rem; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
